import React, { useState } from 'react';
import { InputContainer } from './ResourceArticleSearchInput.styles';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { processLocationQuery } from 'src/functions/processLocationQuery';
import InputSearch from 'molecules/InputSearch/InputSearch';

const ResourceArticleSearchInput = (): JSX.Element => {
  const { search: searchLocation } = useLocation();

  const [search, setSearch] = useState(() => {
    const query = processLocationQuery(searchLocation);

    return query.title || '';
  });

  const handleSearchButtonClick = () => {
    if (search.length > 0) {
      navigate(`/resources?title=${search.toLowerCase()}`);
    }
  };

  return (
    <InputContainer maxWidthLg='width-xs'>
      <InputSearch
        search={search}
        onChange={(value) => setSearch(value)}
        onSearch={handleSearchButtonClick}
      />
    </InputContainer>
  );
};

export default ResourceArticleSearchInput;
